export const props = {
  point: String,
  processDateSelection: {
    type: Function,
    default: () => {}
  },
  datePickerProps: {
    type: Object,
    default() {
      return {}
    }
  },
  hideTimer: {
    type: Boolean,
    default: false
  }
}
